import React from "react";
import { Redirect } from 'react-router-dom';

const Dashboard: React.FC<any> = () => (
  // @ts-ignore – react-router-dom v5 Redirect types are incompatible with @types/react >=18
  <Redirect to="/bookings" />
);
export default Dashboard;
